import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../../../../state/store/store';
import { auditSelectors } from '../../../../../state/ducks/audit/selectors';
import { parseFilterFields, removeFilterItem, parsedFilterFieldType } from '../../utils';
import { AuditLogFilters } from '../../../../../models/entities/audit/auditLog';

type Props = {
    filterFields: Array<{ field: string; value: any }>;
    entityTypes: string[];
    users: Array<{ userId: string; userName: string }>;
    setAuditFilters: (filters: AuditLogFilters) => void;
    localization: any;
};

const FiltersStripe = ({ filterFields, entityTypes, users, setAuditFilters, localization }: Props) => {
    const renderFiltersStrip = () => {
        return parseFilterFields(filterFields || [], localization, entityTypes, users)?.map(
            (filter: parsedFilterFieldType, i) => (
                <FilterBadge key={i}>
                    {filter.parsedValue}
                    <FilterRemove
                        className="material-icons"
                        onClick={() => {
                            const remainingFilters = removeFilterItem(filter, filterFields || []);

                            // Convert back to AuditLogFilters format
                            const newFilters: AuditLogFilters = {};
                            remainingFilters.forEach(({ field, value }) => {
                                (newFilters as any)[field] = value;
                            });

                            setAuditFilters(newFilters);
                        }}
                    >
                        close
                    </FilterRemove>
                </FilterBadge>
            )
        );
    };

    return <FiltersStripeContainer>{renderFiltersStrip()}</FiltersStripeContainer>;
};

const FiltersStripeContainer = styled.div`
    flex: 1;
    padding: 10px 0px;
    margin: 0 25px;
    font-size: 12px;
    display: flex;
    overflow-x: hidden;

    @media screen and (max-width: 768px) {
        display: none;
    }

    &:hover {
        overflow-x: overlay;
    }

    &::-webkit-scrollbar {
        height: 2px;
    }

    &::-webkit-scrollbar-track {
        background-color: white;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
    }
`;

const FilterBadge = styled.span`
    border-radius: 2vh;
    border: 1px solid #008ac9;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    height: 24px;
    padding: 3px 8px;
    margin-left: 10px;
    display: inline-flex;
    align-items: center;
    line-height: 1px;
    min-width: max-content;
`;

const FilterRemove = styled.span`
    font-size: 12px;
    color: #008ac9;
    margin-left: 5px;
    cursor: pointer;
`;

const mapStateToProps = (state: RootState) => ({
    filterFields: auditSelectors.filterFields(state),
    entityTypes: auditSelectors.entityTypes(state),
    users: auditSelectors.auditUsers(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    setAuditFilters: (filters: AuditLogFilters) => {
        dispatch.audit.setCurrentFilters(filters);
        dispatch.audit.fetchAuditLogs(filters, false);
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(FiltersStripe);
